import { render, staticRenderFns } from "./PaymentMethodDetails.vue?vue&type=template&id=d5f32876"
import script from "./PaymentMethodDetails.vue?vue&type=script&lang=js"
export * from "./PaymentMethodDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports